import { FC } from 'react';

export const PreviousTrendLegendMarker: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
    >
      <mask
        id="mask0_46032_31988"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="13"
        height="14"
      >
        <rect y="0.5" width="13" height="13" rx="1" fill="var(--base-white)" />
      </mask>
      <g mask="url(#mask0_46032_31988)">
        <rect
          x="-15"
          y="12"
          width="49"
          height="1"
          transform="rotate(-30 -15 12)"
          fill="var(--base-muted-foreground)"
        />
        <rect
          x="-15"
          y="15"
          width="49"
          height="1"
          transform="rotate(-30 -15 15)"
          fill="var(--base-muted-foreground)"
        />
        <rect
          x="-15"
          y="18"
          width="49"
          height="1"
          transform="rotate(-30 -15 18)"
          fill="var(--base-muted-foreground)"
        />
        <rect
          x="-15"
          y="21"
          width="49"
          height="1"
          transform="rotate(-30 -15 21)"
          fill="var(--base-muted-foreground)"
        />
        <rect
          x="-15"
          y="24"
          width="49"
          height="1"
          transform="rotate(-30 -15 24)"
          fill="var(--base-muted-foreground)"
        />
        <rect
          x="-15"
          y="27"
          width="49"
          height="1"
          transform="rotate(-30 -15 27)"
          fill="var(--base-muted-foreground)"
        />
      </g>
    </svg>
  );
}
